/**
 * Created by sumudu on 5/2/16.
 */
'use strict';

(function () {
    angular.module('aeroLineCrew')
        .controller('AppController', AppController);

    function AppController($location ,$timeout, EventManagerService, AuthService, ApplicationService,  TabService, $window, $state, CommonMasterData, StorageServices, $scope, $uibModal) {
        var vm = this;
        vm.isLoggedIn = AuthService.isLoggedIn();
        vm.allTabs = ApplicationService.getAllOpenTabs();
        vm.selectedTab = ApplicationService.getSelectedTab();
        vm.userInfo = ApplicationService.getLoginInfo();
        vm.isFullScreenActive = false;
        vm.isPrintDocument = $window.popup;
        vm.selectedTabTitle = "";
        vm.selectedMenuOption = "";
        vm.totalAlertMsgCount = 0;
        vm.totalCommanderDiscReptCount = 0;
        vm.screenReport = false;
        if($location.$$url === "/crew-sign-in-screen" || $location.$$url === "/flight-screen" || $location.$$url === "/flight-information-report"){
          vm.screenReport = true;
        }

        EventManagerService.registerEventListener(EventManagerService.EVENT.USER_LOGGED_IN, function appCtrl_onUserLoggedIn () {
            vm.isLoggedIn = AuthService.isLoggedIn();
            vm.userInfo = ApplicationService.getLoginInfo();
        });

        EventManagerService.registerEventListener(EventManagerService.EVENT.USER_LOGGED_OUT, function appCtrl_onUserLoggedOut() {
            vm.isLoggedIn = AuthService.isLoggedIn();
        });

        EventManagerService.registerEventListener(EventManagerService.EVENT.TAB_REMOVED, function appCtrl_onTabRemoved () {
            vm.allTabs = ApplicationService.getAllOpenTabs();
        });

        EventManagerService.registerEventListener(EventManagerService.EVENT.NEW_ALERT_COUNT, function appCtrl_onAlertCountChange () {
          CommonMasterData.getNewAlertMsgCount(function(alertMsgCount) {
            vm.totalAlertMsgCount = alertMsgCount;
          }, function(error) {
            console.log('Alert Msg Count retrieval error!!'+error);
          });
        });

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FULL_SCREEN, function appCtrl_onFullScreen (isFullscreen) {
            vm.isFullScreenActive = isFullscreen;

            if(vm.isFullScreenActive){
                launchFullScreen(document.documentElement)
            }
            else{
                exitFullscreen()
            } // the whole page

        });
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                if(vm.isFullScreenActive){
                    vm.isFullScreenActive = false;
                    exitFullscreen();
                    $timeout(function () {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.SCREEN_MODE_CHANGE,false);
                    },10);
                }
            }
            if(e.keyCode==122){
                vm.isFullScreenActive = !vm.isFullScreenActive;
                if(vm.isFullScreenActive){
                    launchFullScreen(document.documentElement);
                    $timeout(function () {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.SCREEN_MODE_CHANGE,true);
                    },10);
                }
                else{
                    exitFullscreen();
                    $timeout(function () {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.SCREEN_MODE_CHANGE,false);
                    },10);
                }
            }
        });
        function exitFullscreen() {

            if(document.exitFullscreen) {
                document.exitFullscreen();
            } else if(document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if(document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCREEN_SIZE_CHANGE);
        }
        function launchFullScreen(element) {

            if(element.requestFullScreen) {
                element.requestFullScreen();
            } else if(element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if(element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            }
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCREEN_SIZE_CHANGE);
        }

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_LOGGED_OUT , function appCtrl_doLoggedOut () {
            AuthService.setLogoutData();
            if($location.$$url !== "/crew-sign-in-screen" && $location.$$url !== "/flight-screen" && $location.$$url !== "/flight-information-report" ) {
              $location.path('/login');
            }
        });


        EventManagerService.registerEventListener(EventManagerService.EVENT.TAB_SELECTED, function appCtrl_onTabSelected () {
            vm.selectedTab = ApplicationService.getSelectedTab();
            $timeout(function () {
                vm.selectedTabIndex = _.findIndex(vm.allTabs, function (tab) {
                    return tab.state == vm.selectedTab;
                });
                vm.selectedTabTitle = getTabTitle(ApplicationService.getSelectedTabByState(vm.selectedTab));
                vm.selectedMenuOption = getTabMenuCategary(ApplicationService.getSelectedTabByState(vm.selectedTab));
                vm.favicon = getFavicon(ApplicationService.getSelectedTabByState(vm.selectedTab));
            }, 0);
        });

        vm.onLogoutClick = function () {
            AuthService.doLogOut(
                function () {
                    $location.path('/login');
                    $window.location.reload();
                },
                function () {
                    $location.path('/login');
                    console.log('LOGOUT ERROR');
                }
            );
        };

        vm.onTabCloseClick = function (tab) {
            ApplicationService.removeTab(tab);
        };

        vm.onTabClick = function (tab) {
            TabService.gotoTab(tab.state); //$state.go(tab.state);
        };

        vm.onAppLogoClick = function () {
           // TabService.gotoTab('home'); //$state.go('home');
            //TabService.gotoTab('home');
        	TabService.gotoTab('welcome');
        	//$state.go('manageFlight');
        };

        vm.onAlertManagerClick = function () {
          var params = {
            fromDate: moment(new Date()).format('DD/MM/YYYY'),
            toDate : moment(new Date()).format('DD/MM/YYYY')
          };
          var tabName = 'alertManager';
          StorageServices.setTabData(tabName,'alertParams',params);
          var currentTab = ApplicationService.getSelectedTab();
          if(currentTab !== tabName){
        	  TabService.gotoTab(tabName);
          }
        };

        vm.onCmdDiscretionClick = function () {
          var params = {
            fromDate: moment(new Date()).format('DD/MM/YYYY'),
            toDate : moment(new Date()).format('DD/MM/YYYY')
          };
          var tabName = 'adminCommanderDiscretion';
          StorageServices.setTabData(tabName,'reportParam',params);
          var currentTab = ApplicationService.getSelectedTab();
          if(currentTab !== tabName){
            TabService.gotoTab(tabName);
          }
        };

        vm.changePasswordClick = function () {
        	$timeout(function(){
        		var loginInfo = ApplicationService.getLoginInfo();
        		AuthService.setLogoutData();
        		vm.isLoggedIn = false;
        		$state.go('reset');
        		ApplicationService.setLoginInfo(loginInfo);
        	})
        };

        function getTabTitle(tabObj){
            var tabTitle = '';
            /*if(tabObj.name.toLowerCase()!=='home'){
                tabTitle = tabObj.name;
            }*/
            if(tabObj.name.toLowerCase()!=='welcome'){
                tabTitle = tabObj.name;
            }

            return tabTitle;
        }

        function getTabMenuCategary(tabObj){
        	return tabObj.pageBelongsToTheMenu;
        }

        function getFavicon (tabObj) {
            var  favicon = (tabObj && !!tabObj.favicon && tabObj.favicon ) || 'favicon_default.ico';
            return favicon+'?v='+Math.floor(Math.random()*1000);
        }

        $( window ).on('unload',function() {
            var path = this.name;
            TabService.removeTab(path);
        });

        $( window ).on('load', function () {
            var path = this.name;
            TabService.addTab(path);
            var pageName = this.name;
            $timeout(function () {
                vm.isPrintDocument = $window.popup || pageName.indexOf('print')>-1;
            });

        });

        vm.closeModal = function() {
          if($scope.warning ) {
            $scope.warning.close();
            $scope.warning = null;
          }
        };

        $scope.$on('IdleStart', function() {
          vm.closeModal();

          $scope.warning = $uibModal.open({
            templateUrl: 'warning-dialog.html',
            windowClass: 'modal-warning'
          });
        });

        $scope.$on('IdleTimeout', function() {
          vm.closeModal();
          vm.onLogoutClick();
        });

        $scope.$on('IdleEnd', function() {
          vm.closeModal();
        });

        (function() {
			// get new Alert Message Count
			CommonMasterData.getNewAlertMsgCount(function(alertMsgCount) {
				vm.totalAlertMsgCount = alertMsgCount;
			}, function(error) {
				console.log('Alert Msg Count retrieval error!!'+error);
			});

       CommonMasterData.getCommanderDiscReptCount(function(reptCount) {
          vm.totalCommanderDiscReptCount = reptCount;
       }, function(error) {
           console.log('Report Count retrieval error!!'+error);
       });
		})();
    }

  $(window).resize(function () {
    if ($(".tabbed-view-container").height() == 0) $(".tabbed-view-container").height(80);
    var spacebarHeight = 0;
    if (!!$(".space_bar")) {
      spacebarHeight = $(".space_bar").height();
    }
    var height = ($("header").height() + $(".tabbed-view-container").height() + spacebarHeight) + "px";
    $(".canvas").css("top", height);
  });
}());

